import { render } from "./Expenses.vue?vue&type=template&id=79e276e4&scoped=true"
import script from "./Expenses.vue?vue&type=script&lang=js"
export * from "./Expenses.vue?vue&type=script&lang=js"

import "./Expenses.vue?vue&type=style&index=0&id=79e276e4&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e276e4"]])

export default __exports__